import { combineReducers } from "redux";
import { gameReducer, graphReducer } from "./reducers";

const mainReducer = combineReducers({
  graph: graphReducer,
  game: gameReducer,
});
export default mainReducer;
